import { createFormattedInput } from "src/common/components/FormattedInput";

export const SocialSecurityNumberInput = createFormattedInput(formatValue);

function formatValue(value: string | undefined): string | undefined {
	if (value === undefined) {
		return;
	}
	const cleanValue = value.replace(/[\s-]/g, "");
	const matches = cleanValue.match(/.{1,3}/g);
	return matches ? matches.join("-") : cleanValue;
}
